<template>
    <div class="paperpile_section_wrp">
        <div class="paperpile_content_wrp">
            <div class="paperpile_content_header">
                <div class="row align-items-center">
                    <div class="col">
                        <h2 class="rfiles_main_heading"><button type="button" class="btn back_btn" tapable
                                @click="$router.go(-1)">
                                <i class="fa fa-chevron-left" aria-hidden="true"></i>
                            </button>Trash</h2>
                    </div>
                    <div class="col-auto">
                        <ul class="rfiles_header_right_side">
                            <li>
                             <button class="btn btn-primary" @click="allClearTrashPaperMethod">Empty Trash</button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="paperpile_content_list_wrp mt-4">
                <div class="paperpile_content_list_section" v-if="paperPileDetails">
                    <ul class="paperpile_content_list_inner"
                        v-if="paperPileResults.length > 0 || trashFolderListResults.length > 0">
                        <template v-if="paperPileResults.length > 0">
                            <li class="listed_heading">
                                <h4>Papers - <svg xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs"
                                        version="1.1" width="22" height="22" x="0" y="0" viewBox="0 0 247 247"
                                        xml:space="preserve">
                                        <g>
                                            <path xmlns="http://www.w3.org/2000/svg"
                                                d="M171.333,48c-4.143,0-7.833-3.357-7.833-7.5V0H41.333C37.19,0,33.5,3.357,33.5,7.5v231c0,4.133,3.51,7.737,7.644,7.75  L206.311,247c0.008,0,0.015,0,0.015,0c1.993,0,3.731-1.037,5.136-2.438c1.412-1.407,2.039-3.568,2.039-5.562V48H171.333z   M171.833,181h-99c-4.143,0-7.5-3.357-7.5-7.5s3.357-7.5,7.5-7.5h99c4.143,0,7.5,3.357,7.5,7.5S175.976,181,171.833,181z   M171.833,148h-99c-4.143,0-7.5-3.357-7.5-7.5s3.357-7.5,7.5-7.5h99c4.143,0,7.5,3.357,7.5,7.5S175.976,148,171.833,148z   M171.833,115h-99c-4.143,0-7.5-3.357-7.5-7.5s3.357-7.5,7.5-7.5h99c4.143,0,7.5,3.357,7.5,7.5S175.976,115,171.833,115z   M171.833,84h-99c-4.143,0-7.5-3.357-7.5-7.5s3.357-7.5,7.5-7.5h99c4.143,0,7.5,3.357,7.5,7.5S175.976,84,171.833,84z M210.767,33  H178.5V2.383L210.767,33z"
                                                fill="#fff8d8" data-original="#000000"></path>
                                            <g xmlns="http://www.w3.org/2000/svg"></g>
                                            <g xmlns="http://www.w3.org/2000/svg"></g>
                                            <g xmlns="http://www.w3.org/2000/svg"></g>
                                            <g xmlns="http://www.w3.org/2000/svg"></g>
                                            <g xmlns="http://www.w3.org/2000/svg"></g>
                                            <g xmlns="http://www.w3.org/2000/svg"></g>
                                            <g xmlns="http://www.w3.org/2000/svg"></g>
                                            <g xmlns="http://www.w3.org/2000/svg"></g>
                                            <g xmlns="http://www.w3.org/2000/svg"></g>
                                            <g xmlns="http://www.w3.org/2000/svg"></g>
                                            <g xmlns="http://www.w3.org/2000/svg"></g>
                                            <g xmlns="http://www.w3.org/2000/svg"></g>
                                            <g xmlns="http://www.w3.org/2000/svg"></g>
                                            <g xmlns="http://www.w3.org/2000/svg"></g>
                                            <g xmlns="http://www.w3.org/2000/svg"></g>
                                        </g>
                                    </svg></h4>
                            </li>
                            <li v-for="(items, index) in paperPileResults" :key="items.id">
                                <div class="row align-items-center">
                                    <div class="col-auto pr-0"><span class="paper_number">{{ index + 1 }}.</span></div>
                                    <div class="col">
                                        <div class="rfiles_list_title">
                                            <div class="row align-items-center">
                                                <div class="col">
                                                    <h3>{{ items.title }}</h3>
                                                </div>
                                                <!-- <div class="col-auto ml-auto">
                            <div class="paper_for_fav_wrp">
                              <template v-if="items.is_favourite">
                                <i class="fa fa-star" aria-hidden="true"></i>
                              </template>
<template v-else>
                                <i class="fa fa-star-o" aria-hidden="true"></i>
                              </template>
</div>
</div> -->
                                            </div>
                                        </div>
                                        <div class="files_directory_path" v-if="items.parent_directory">
                                            <h3>../{{ items.parent_directory }}</h3>
                                        </div>
                                        <div class="rfiles_list_action">
                                            <div class="row align-items-center">
                                                <div class="col">
                                                    <ul class="rfiles_action_list_wrp">
                                                        <li @click="trashPaperRestoreMethod(items.id, 'paper')">Restore
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </template>
                        <template v-if="trashFolderListResults.length > 0">
                            <li class="listed_heading mt-4">
                                <h4 style="color: #ffe9e9;">Shelfs - <i aria-hidden="true" class="fa fa-folder"
                                        style="color: #ffe9e9;"></i></h4>
                            </li>
                            <li v-for="(items, index) in trashFolderListResults" :key="items.id"
                                class="shelf_trash_data">
                                <div class="row align-items-center">
                                    <div class="col-auto pr-0"><span class="paper_number">{{ index + 1 }}.</span></div>
                                    <div class="col">
                                        <div class="rfiles_list_title">
                                            <h3>{{ items.name }}</h3>
                                        </div>
                                        <div class="files_directory_path" v-if="items.parent_directory">
                                            <h3>../{{ items.parent_directory }}</h3>
                                        </div>
                                        <div class="rfiles_list_action">
                                            <div class="row align-items-center">
                                                <div class="col">
                                                    <ul class="rfiles_action_list_wrp">
                                                        <li @click="trashPaperRestoreMethod(items.id, 'shelf')">Restore
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </template>
                    </ul>
                    <div class="no_have_papers_text" v-else>Your trash bin is empty</div>
                </div>
                <div class="fixloader userLoading" v-if="userLoading">
                    <div class="spinner spinner-1"></div>
                </div>
            </div>
        </div>
        <paper-restore v-if="trashPaperRestoreState" :trashPaperID="trashPaperId"
            :trashItemNAME="trashItemName"></paper-restore>
        <all-clear-trash-paper v-if="clearAllTrshPaperState"></all-clear-trash-paper>
    </div>
</template>

<script>
/*eslint-disable */
const $ = window.jQuery = require('jquery');
import ppLeftSidebar from '../paperpile-left-sidebar';
import axios from 'axios';
import trashPaperRestore from '../trash-paper-restore';
import allClearTrashPaper from '../clear-all-trash';
import {
    mapGetters,
} from 'vuex';
import {
    bus
} from '@/main';
export default {
    name: 'trash-paper-list',
    components: {
        'pp-left-sidebar': ppLeftSidebar,
        'paper-restore': trashPaperRestore,
        'all-clear-trash-paper': allClearTrashPaper
    },
    props: [],
    data() {
        return {
            paperPileDetails: null,
            paperPileResults: [],
            nextPageUrl: '',
            nextSteper: '',
            userLoading: false,
            trashPaperRestoreState: false,
            trashPaperId: '',
            trashFolderData: null,
            trashFolderListResults: [],
            trashItemName: '',
            clearAllTrshPaperState: false
        }
    },
    computed: {
        ...mapGetters([
            'getTrashaperListGetters',
            'getTrashFolderListGetters'
        ]),
        getPaperPileDetails() {
            this.paperPileDetails = this.$store.getters.getTrashaperListGetters.data;
            return
        },
        getPaperPileResultsIntialsState() {
            if (this.paperPileDetails) {
                this.nextPageUrl = this.paperPileDetails.next
                this.nextSteper = this.paperPileDetails.next
                this.paperPileResults = [].concat(this.paperPileDetails.results)
            }
            return
        },
        getTrashFolderData() {
            this.trashFolderData = this.$store.getters.getTrashFolderListGetters.data;
            return
        },
        getTrashFolderIntialsState() {
            if (this.trashFolderData) {
                this.trashFolderListResults = [].concat(this.trashFolderData.results)
            }
            return
        },
    },
    mounted() {
        this.getPaperPileDetails
        this.getPaperPileResultsIntialsState
        this.getTrashFolderData
        this.getTrashFolderIntialsState
        bus.$on('trashPaperRestoreStateBus', (data) => {
            this.trashPaperRestoreState = data;
        });
        bus.$on('clearAllTrshPaperBus', (data) => {
            this.clearAllTrshPaperState = data;
        });
    },
    methods: {
        allClearTrashPaperMethod() {
            this.clearAllTrshPaperState = true
            $('body').addClass('body_right_scroll_remove')
        },
        trashPaperRestoreMethod(ID, ItemName) {
            this.trashItemName = ItemName
            this.trashPaperId = ID
            this.trashPaperRestoreState = true
            $('body').addClass('body_right_scroll_remove')
        },
        showLoadMoreDataFun(url) {
            this.userLoading = true
            axios.get(url).then((response) => {
                this.nextSteper = response.data.data.next
                this.paperPileResults = [].concat(this.paperPileResults, response.data.data.results);
                this.userLoading = false
            });
        },
    },
    watch: {
        getPaperPileDetails() {
            return this.$store.getters.getTrashaperListGetters;
        },
        getPaperPileResultsIntialsState() {
            if (this.paperPileDetails != undefined) {
                this.nextPageUrl = this.paperPileDetails.next
                this.paperPileResults = [].concat(this.paperPileDetails.results)
            }
            return
        },
        nextSteper(old_val, new_val) {
            if (old_val != '') {
                this.nextPageUrl = old_val
            }
        },
        getTrashFolderData() {
            return this.$store.getters.getTrashFolderListGetters
        },
        getTrashFolderIntialsState() {
            if (this.trashFolderData) {
                this.trashFolderListResults = [].concat(this.trashFolderData.results)
            }
            return
        },
    },
}
</script>

<style lang="scss" scoped>
.paperpile_section_wrp {
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    height: 100%;

    a {
        text-decoration: none;
    }

    &>.row {
        min-height: calc(100dvh - 80px);
    }

    .btn-primary {
        cursor: pointer;
        position: relative;
        min-width: 95px;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        outline: none !important;
        background: rgba(255, 255, 255, 0.12);
        color: #ffffff;
        border: none;
        border-radius: 3px;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        font-size: 18px;

        &:hover {
            background: #87cefa;
            color: #22292f;
        }
    }

    .paperpile_content_header {
        padding: 0px 15px 20px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.05);
        margin: 0 -15px;

        .rfiles_main_heading {
            color: #ffffff;
            font-size: 24px;
            text-transform: uppercase;
            font-weight: bold;
            margin: 0px;
        }

        .rfiles_main_subheading {
            margin: 0;
            font-size: 14px;
            color: #ffd700;
        }

        .rfiles_searchbar {
            position: relative;

            .fa {
                font-size: 18px;
                cursor: pointer;
                color: #c0c0c0;
                position: absolute;
                top: 10px;
                left: 10px;
            }

            &:focus-within {
                .fa {
                    color: #ffd700;
                }
            }

            .form-control {
                background: linear-gradient(-30deg, rgba(37, 44, 84, 0.6) 0%, rgba(0, 0, 0, 0.6) 50%, rgba(38, 38, 38, 0.6) 50%, rgba(44, 44, 84, 0.6) 100%);
                box-shadow: -5px 5px 10px rgba(82, 106, 133, 0.06);
                font-size: 18px;
                color: #ffd700;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
                border: 1px solid rgba(93, 93, 93, 0.5);
                height: auto;
                width: 280px;
                line-height: 38px;
                padding: 0px 15px 0 40px;
                -webkit-box-shadow: none;
                box-shadow: none;

                &:hover {
                    border-color: #ffd700;
                }

                &:focus {
                    border-color: #ffd700;
                }

                @media only screen and (max-width:769px) {
                    width: 100%;
                }

                &::-moz-placeholder {
                    color: #dfdfdf;
                }

                &::-webkit-input-placeholder {
                    color: #dfdfdf;
                }

                &:focus::-webkit-input-placeholder {
                    font-size: 0px;
                }

                &:focus::-moz-placeholder {
                    font-size: 0px;
                }
            }
        }

        .rfiles_header_right_side {
            display: flex;
            align-items: center;
            margin-bottom: 0px;

            li {
                margin-right: 10px;

                &:last-child {
                    margin-right: 0px;
                }
            }

            .btn-primary {
                cursor: pointer;
                position: relative;
                min-width: 95px;
                -webkit-box-shadow: none !important;
                box-shadow: none !important;
                outline: none !important;
                background: #b41818;
                color: #ffffff;
                border: none;
                border-radius: 3px;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
                font-size: 18px;
                letter-spacing: 0.5px;

                @media only screen and (max-width:769px) {
                    font-size: 16px;
                    padding: 6px;
                }

                &:hover {
                    background: #87cefa;
                    color: #22292f;
                }
            }
        }
    }

    .paperpile_content_wrp {
        background: rgba(9, 9, 9, 0.95);
        -webkit-box-shadow: -3px 1px 10px rgba(138, 145, 153, 0.05);
        box-shadow: -3px 1px 10px rgba(138, 145, 153, 0.05);
        border-radius: 5px;
        padding: 15px;
        height: 100%;

        @media only screen and (max-width:769px) {
            min-height: calc(100dvh - 90px);
        }
    }

    .paperpile_content_list_inner {
        margin: 0px;

        &>li {
            background: linear-gradient(-30deg, rgba(37, 44, 84, 0.98), rgba(0, 0, 0, 0.98) 50%, rgba(38, 38, 38, 0.98) 0, rgba(44, 44, 84, 0.98));
            padding: 25px;
            border-radius: 20px;
            margin-bottom: 10px;
            border: 1px solid rgba(93, 93, 93, 0.5);

            &.listed_heading {
                background: none;
                padding: 0;
                border: none;

                h4 {
                    color: #fff8d8;
                    font-size: 24px;
                    line-height: 1;
                }
            }

            .rfiles_list_title {
                margin-bottom: 0px;

                h3 {
                    font-size: 22px;
                    color: #d6d6d6;
                    margin-bottom: 0px;
                    line-height: 1;
                }
            }

            &.shelf_trash_data {
                // background: rgba(112, 162, 41, 0.3);

                .rfiles_list_title {
                    h3 {
                        color: #f5f5f5;
                    }
                }
            }

            .files_directory_path {
                margin-top: 5px;

                h3 {
                    font-size: 14px;
                    color: #878787;
                    margin: 0;
                    line-height: 1;
                    font-weight: normal;
                    font-family: 'MyriadProRegular', 'Lato', sans-serif;
                }
            }

            .rfiles_list_action {
                border-top: 1px solid rgba(255, 255, 255, 0.05);
                padding-top: 10px;
                position: relative;
                margin-top: 10px;
            }

            .rfiles_action_list_wrp {
                display: flex;
                align-items: center;

                li {
                    margin-right: 15px;
                    font-size: 16px;
                    color: #ffe9e9;
                    cursor: pointer;
                    border: 1px solid #ffe9e9;
                    padding: 0 20px;
                    line-height: 30px;
                    border-radius: 30px;

                    &:hover {
                        background: #ffe9e9;
                        color: #000000;
                    }

                }
            }

            .paper_for_fav_wrp {
                .fa {
                    font-size: 18px;
                    color: #fff8d8;
                    cursor: pointer;
                    line-height: 1.3;

                    &:hover {
                        color: #87cefa;
                    }
                }
            }

            .paper_number {
                font-size: 18px;
                color: #fff8d8;
            }
        }
    }

    .load_more_btn {
        color: #fff !important;
        background: rgba(255, 255, 255, 0.1);
        padding: 5px;
        min-width: 110px;
        font-size: 16px;
        border-radius: 3px;
        border: 0 !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        margin: 15px 0;

        &:hover {
            color: #000 !important;
            background: #87cefa;
        }
    }

    .fixloader {
        align-items: flex-end;
    }

    .load_more_li_wrp {
        text-align: center;
    }

    .no_have_papers_text {
        text-align: center;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        font-size: 18px;
        color: #ffffff;
        background: rgba(255, 255, 255, 0.08);
        padding: 50px 15px;
        border-radius: 5px;
        margin-bottom: 10px;
    }

    .paper_trash_btn {
        font-size: 20px;
        cursor: pointer;
        color: #fff8d8;

        &:hover {
            color: #87cefa;
        }
    }
}
</style>